
































































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import userModel from '@/store/modules/user';
import * as api from '@/api';
import * as models from '@/api/models';
import UserModule from '@/store/modules/user';
import axios from 'axios';
import { Dialog } from 'vant';

@Component({ components: {} })
export default class Audit extends Vue {
  stuImgs: any = [];
  isDisabled: boolean = false;
  currentInfo: any = {};
  btnLoding: boolean = false;
  form: models.BatchAduitDto = {
    ids: [],
    auditState: null,
    /**
     * 干教处审核时 需要设置是否做退学处理
     */
    isDropOut: null,
    /**
     * 保留原因 (如果不做退学处理时保留学时的原因)
     */
    retainReason: '',
    /**
     * 审核意见
     */
    auditOpinion: '',
  };
  isLoading: boolean = false;

  get CommonAuditStatus() {
    return models.CommonAuditStatus;
  }

  get userType() {
    return parseInt(UserModule.info.type);
  }

  get TimeSlot() {
    return models.TimeSlot;
  }

  ViewerClick() {
    console.log('%c [9999 ]-201', 'font-size:13px; background:pink; color:#bf2c9f;', 999);
  }

  async mounted() {
    if (this.$route.query.type) {
      if (this.$route.query.type == '请假详情') this.isDisabled = true;
      else this.isDisabled = false;
    }

    if (this.$route.query.auditInfo) {
      this.currentInfo = JSON.parse(this.$route.query.auditInfo as any);
      Object.keys(this.form).forEach(key => {
        if (key in this.currentInfo && key != 'auditState') this.form[key] = this.currentInfo[key];
      });
      if (this.userType == 3) {
        this.form.auditOpinion = this.currentInfo.orgAuditOpinion;
        this.form.auditState = this.currentInfo.orgAuditStatus;
      } else {
        this.form.auditState = this.currentInfo.auditStatus;
      }
      if (this.currentInfo.attachmentKey) {
        this.getStuImg('请假条', this.currentInfo.attachmentKey);
      }
    }
  }

  async getStuImg(keyName: string, key: string) {
    const { data } = await apiAxios.get('/api/NewAttachment/GetAttachmens', {
      params: {
        StringKey1: key,
        Category: keyName,
      },
    });
    this.stuImgs = data;
  }

  onClickLeft() {}

  async onSubmit() {
    this.btnLoding = true;
    this.form.ids = [this.currentInfo.id];
    if (this.userType == 3) {
      try {
        const data = await api.Leaves.orgBatchAduit_POST(this.form);
        if (data.success) {
          Dialog.alert({
            title: '提示',
            message: '提交成功',
          }).then(() => {
            this.$router.go(-1);
          });
        } else {
          Dialog.alert({
            title: '提示',
            message: '提交失败' + data.message,
          });
        }
        this.btnLoding = false;
      } catch (error) {
        console.log(error.toString());
        this.btnLoding = false;
      }
    }
    if (this.userType == 2) {
      try {
        const data = await api.Leaves.adminBatchAduit_POST(this.form);
        if (data.success) {
          Dialog.alert({
            title: '提示',
            message: '添加成功，请耐心等待审核',
          }).then(() => {
            this.$router.go(-1);
          });
        } else {
          Dialog.alert({
            title: '提示',
            message: '添加失败' + data.message,
          });
        }
      } catch (error) {
        console.log(error.toString());
      }
    }
  }
}
const axiosOptions: AxiosRequestConfig = {
  baseURL: process.env.VUE_APP_ROOT,
  headers: {
    Authorization: `${'Bearer ' + UserModule.getToken}`,
    'Content-Type': 'application/json',
    'X-Requested-With': 'XMLHttpRequest',
  },
};
const apiAxios = axios.create(axiosOptions);

export interface AxiosRequestConfig {
  baseURL?: string;
  headers: object;
}
